/*
 JS Specific for the Exercise sub page
 */

var viewportWidth = function(){
	var width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
	return width;
}
exercise = {
	// an object that is only called on the exercise pages
	init: function initialize(){
		this.cE();
		this.wA();
	},
	cE: function cacheElements(){
		/*
		 * If page is less than or equal to 600px AND supports touchevents, then cache it's state via exercise.VPM
		 */
		exercise.VPM = false; // viewport mobile
		if(viewportWidth() <= 600 && Modernizr.touchevents){
			exercise.VPM = true;
		}

		/*
		 * TIPS FOR STICKING
		 */
		exercise.stopwatchSvg = {};
		exercise.stopwatchSvg.el = document.querySelector("svg.stopwatch");
		exercise.stopwatchSvg.left = exercise.stopwatchSvg.el.querySelector(".left");
		exercise.stopwatchSvg.all = exercise.stopwatchSvg.el.querySelector(".all");
		exercise.stopwatchSvg.dots = exercise.stopwatchSvg.el.querySelector(".dots");

		exercise.runningSvg = {};
		exercise.runningSvg.el = document.querySelector("svg.running");
		exercise.runningSvg.rays = exercise.runningSvg.el.querySelector(".rays");

		exercise.greenWatchSvg = {};
		exercise.greenWatchSvg.el = document.querySelector("svg#green-watch");
		exercise.greenWatchSvg.bg = exercise.greenWatchSvg.el.querySelector("#half-circle");
		exercise.greenWatchSvg.hand = exercise.greenWatchSvg.el.querySelector("#hand");

		exercise.triSvg = {};
		exercise.triSvg.el = document.querySelector("svg.tri");
		exercise.triSvg.bike = exercise.triSvg.el.querySelector(".bike");
		exercise.triSvg.front = exercise.triSvg.el.querySelector(".front");
		exercise.triSvg.back = exercise.triSvg.el.querySelector(".back");

	},

	wA: function webAnimations(){

		exercise.stopwatchSvg.leftAnimation = exercise.stopwatchSvg.left.animate([
			{ fill:"#B4EDFC" },
			{ fill:"#97D9E8" }
		], {
			direction: 'alternate',
			duration: 1000,
			iterations: Infinity
		});
		exercise.stopwatchSvg.dotsAnimation = exercise.stopwatchSvg.dots.animate([
			{ opacity:1, offset:0.0 },
			{ opacity:1, offset:0.49 },
			{ opacity:0, offset:0.5 },
			{ opacity:0, offset:1.0 }
		], {
			direction: 'normal',
			duration: 2000,
			iterations: Infinity
		});
		exercise.stopwatchSvg.allAnimation = exercise.stopwatchSvg.all.animate([
			{ fill:"#97D9E8" },
			{ fill:"#B4EDFC" }
		], {
			direction: 'alternate',
			duration: 1000,
			iterations: Infinity
		});


		exercise.runningSvg.raysAnimation = TweenMax.to(exercise.runningSvg.rays, 50, {
			rotation:360,
			transformOrigin:"50% 50% 0px",
			ease:Linear.easeInOut,
			repeat:-1
		});

		var ticker = 0;

		exercise.greenWatchSvg.handAnimation = TweenMax.to(exercise.greenWatchSvg.hand, 1, {
			repeat:-1,
			transformOrigin:"50% 80.50458716%",
			onRepeat:onRepeat,
			ease:Linear.easeNone
		});

		function onRepeat() {
			TweenMax.set(exercise.greenWatchSvg.hand, {rotation: ticker+=30});
		}
	},



} // end exercise
